var getNative = require("./_getNative"), root = require("./_root");
var DataView = getNative(root, "DataView");
module.exports = DataView;
